module.exports = __webpack_public_path__ + "media/images/top/original01-0327962a39a3dd4c8036b9db8e01a1a2.jpg";